<div #MapSizeObsContainer style="width: 100%; height: 100%; background-color: black;">
  <div style="width: 100%; height: 100%;" id="map_window"></div>
</div>
